import React from "react";

function WorkSmatter() {
  return (
    <div className="WorkSmatter_container">
      <div className="WorkSmatter_heading">
        <h3>
          <strong>Work smarter</strong>, by using AI not manually
        </h3>
        <p>Scale faster and improve customer loyalty. No more back & forth.</p>
      </div>
      <div className="workSmatter_info">
        <div className="workSmatter_info-facts">
          <div className="facts_title">
            ✅<h4>Detailed analytics</h4>
          </div>
          <p>
            See the full picture of all your candidates in one place and take
            action immediately.
          </p>
        </div>

        <div className="workSmatter_info-facts">
          <div className="facts_title">
            ✅<h4>Clients overview</h4>
          </div>
          <p>
            Track and manage all clients requests very easy without back and
            forth.
          </p>
        </div>
      </div>
    </div>
  );
}

export default WorkSmatter;
